import intersection from 'lodash.intersection';
import findByMatchingProperties from 'utils/find-matching-properties';

export default function passesMultiCheckboxFilter(item, filter) {
    // IF the active filter does not have values then we pass the check without question
    if (!filter.values.length) { return true; }

    // Find the filter option on the item that matches the active filter
    const matchedItemFilterOptions = findByMatchingProperties(item.filterOptions, { code: filter.code });

    // if we did not find a match, then this item does not pass the filtering
    if (!matchedItemFilterOptions || !matchedItemFilterOptions.length) { return false; }

    // then check if all matched filter options have a match between their values array and the filter's values
    // if the array returned by intersection() has a length greater than zero, than it means there's a match
    const noMatch = matchedItemFilterOptions.find(option => {
        const upperCaseOptionValues = option.values.map(value => value.toUpperCase());
        const upperCaseFilterValues = filter.values.map(value => value.toUpperCase());
        return !intersection(upperCaseOptionValues, upperCaseFilterValues).length;
    });
    return noMatch === undefined;
}
